<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {

  // 在 Vue 组件的 created 钩子中添加检测逻辑
  created() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // 如果是移动设备，重定向到移动端页面
      window.location.href = 'https://baidu.com';
    }
  }
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

.nav-title {
  font-weight: 400;
  font-size: 18px;
  color: #AD7F5A;

  span:nth-child(1) {
    font-size: 48px;
    color: #2F2F2F;
  }

  span:nth-child(2) {
    margin: 0 40px;
  }
}

.mb-54 {
  margin-bottom: 54px;
}
</style>
